import type { QuoteImportResult } from '@everplan/shared';

export function mapParseResultToFormData(parseResult: QuoteImportResult, fileName?: string) {
  return {
    name: fileName ?? parseResult.vendorName,
    packages: parseResult.packages.map((pkg) => ({
      name: pkg.name,
      description: pkg.description,
      isSelected: parseResult.packages.length === 1,
      statedTotal: pkg.statedTotal,
      lineItems: pkg.lineItems.map((item) => ({
        name: item.name,
        description: item.description,
        quantity: item.quantity,
        unitCost: item.unitCost,
        section: item.section,
        notes: null,
      })),
      additionalCharges: pkg.additionalCharges.map((charge) => ({
        type: charge.type,
        description: charge.description,
        amount: charge.amount,
        calcMethod: charge.calcMethod,
        rateBps: charge.rateBps,
        basis: charge.basis,
        inferenceSource: charge.inferenceSource,
        confidence: charge.confidence,
      })),
    })),
    addOns: parseResult.addOns.map((addOn) => ({
      name: addOn.name,
      description: addOn.description,
      quantity: addOn.quantity,
      unitCost: addOn.unitCost,
      section: addOn.section,
      notes: null,
    })),
    additionalCharges: parseResult.additionalCharges.map((charge) => ({
      type: charge.type,
      description: charge.description,
      amount: charge.amount,
      calcMethod: charge.calcMethod,
      rateBps: charge.rateBps,
      basis: charge.basis,
      inferenceSource: charge.inferenceSource,
      confidence: charge.confidence,
    })),
  };
}
